import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './NoticeEdit.module.css';
import TuiEditor from '../../../components/common/TuiEditor';
import { getNoticeById, updateNoticeAPI } from '../../../mock/noticeMockData';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';

export default function NoticeEdit() {
  const { noticeId } = useParams();
  const navigate = useNavigate();
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [initialTitle, setInitialTitle] = useState('');
  const [initialContent, setInitialContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotice = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/notice/${noticeId}`);
  
        if (response.data.code === 1) {
          const notice = response.data.data;
          setInitialTitle(notice.title || '');
          setInitialContent(notice.content || '');
        } else {
          setError('공지사항 정보를 불러오는 데 실패했습니다.');
        }
      } catch (error) {
        setError('공지사항 정보를 불러오는 중 오류가 발생했습니다.');
        console.error('공지사항 데이터 로딩 오류:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchNotice();
  }, [noticeId]);

  // 공지사항 수정 핸들러 (TuiEditor에서 제목과 내용을 받음)
  const handleNoticeSubmit = async (editorContent, editorTitle) => {
    // 제목은 TuiEditor에서 처리하므로 editorTitle 사용
    if (!editorTitle || !editorTitle.trim()) {
      alert('제목을 입력해주세요.');
      return Promise.reject(new Error('제목이 필요합니다.'));
    }

    // 내용 검증
    if (!editorContent || !editorContent.trim()) {
      alert('내용을 입력해주세요.');
      return Promise.reject(new Error('내용이 필요합니다.'));
    }

    setIsSubmitting(true);
      const noticeData = {
        title: editorTitle.trim(),
        content: editorContent
      };

      console.log('수정된 공지사항 데이터:', noticeData);
      
      // API 호출
      try {
        const response = await axios.put(`${API_BASE_URL}/api/v1/admin/notice/${noticeId}`, noticeData);

        if (response.data.code === 1) {
          // 수정 완료 후 상세 페이지로 이동
          navigate(`/notices/${noticeId}`);
          return true;
        } else {
          alert('공지사항 수정에 실패했습니다.');
          return Promise.reject(new Error('수정 실패'));
        }
      } catch (error) {
      console.error('공지사항 수정 오류:', error);
      alert('공지사항 수정 중 오류가 발생했습니다.');
      return Promise.reject(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/notices/${noticeId}`);
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingWrapper}>
          <div className={styles.loading}>로딩 중...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.errorWrapper}>
          <div className={styles.error}>{error}</div>
          <button onClick={handleCancel} className={styles.backButton}>
            돌아가기
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.editorSection}>
        <TuiEditor
          initialTitle={initialTitle}   // 기존 제목
          initialContent={initialContent} // 기존 내용
          onSubmit={handleNoticeSubmit}
          isSubmitting={isSubmitting}
          submitButtonText="수정하기"
        />
      </div>
    </div>
  );
}